import React from "react";
import Checkbox from '@mui/material/Checkbox'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Document, Page, Font  } from '@react-pdf/renderer'
import Results from '../../Components/Results'
import { globalStyles } from '../../Styles'
import { cloneDeep } from 'lodash'
import "../../Styles/Modal.css";
import sofiaProLight from '../../Assets/Fonts/Sofia_Pro_Light.ttf'
import sofiaProMedium from '../../Assets/Fonts/Sofia_Pro_Medium.ttf'
import sofiaProBold from '../../Assets/Fonts/Sofia_Pro_Bold.ttf'
import sofiaProItalic from '../../Assets/Fonts/Sofia_Pro_Medium_Italic.ttf'

Font.register({
    family: 'sofiaProLight',
    src: sofiaProLight,
})
Font.register({
    family: 'sofiaProMed',
    src: sofiaProMedium,
})
Font.register({
    family: 'sofiaProBold',
    src: sofiaProBold,
})
Font.register({
    family: 'sofiaProMedItalic',
    src: sofiaProItalic
})

interface Props {
  data: any,
  classes: any,
  fileName: string,
  selectedCategories: string[],
  setSelectedCategories: (value: string[]) => void,
}

const categories = [
    'General Demography',
    'Medical History',
    'Disease',
    'Social Determinants',
    'Where Care Is Delivered',
/*
    'Labs',
    'Genomics Data Model Germline',
    'Genomics Data Model Somatic',
    'Genomics Pdf Genomic',
    'Genomics Pdf Report',
    'Genomics Vcf Gene Variant',
    'Genomics Vcf Star Allele',
    'Genomics Vcf Transcript',
    'Genomics Vcf Variant'
*/
]

const DataDownload = ({
  data,
  classes,
  fileName,
  selectedCategories,
  setSelectedCategories,
}: Props) => {
  return (
            <FormGroup>
                {categories.map((category: string) => {
                    return (
                        <div className="row" key={category}>
                            <div className="column">
                                <FormControlLabel 
                                    label={category}
                                    control={<Checkbox 
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => { 
                                            const copySelectedCategories = cloneDeep(selectedCategories)
                                            if( event.target.checked ) {
                                                copySelectedCategories.push(category)
                                            } else {
                                                const index = copySelectedCategories.indexOf(category);
                                                if (index > -1) {
                                                    copySelectedCategories.splice(index, 1);
                                                } 
                                            }
                                        setSelectedCategories(copySelectedCategories)
                                        }}
                                        checked={selectedCategories.includes(category)}
                                    />}
                                />
                            </div>
                        </div>    
                    )
                })}
           </FormGroup>
  );
};

export default DataDownload;

